<div class="container-full has-background-white-bis mb-8">
  <div class="container">
    <div class="columns">
      <div class="column">
        <app-breadcrumb></app-breadcrumb>
      </div>
    </div>
  </div>
</div>
<div class="container mb-9">
  <div class="columns is-multiline">
    <div class="column is-12">
      <div class="content">
        <h1 class="title is-2 has-text-weight-bold has-line">
          Indicators & analysis
        </h1>
      </div>
    </div>

    <div class="column is-12">
      <p>
        The OECD INNOTAX portal provides an overview of some key outputs of the
        OECD measurement and analytical work on R&D tax incentives and a link to
        related OECD work in this area. It presents the latest indicators of
        Government Tax Relief for R&D (GTARD) and implied marginal R&D tax
        subsidy rates based on the B-Index. These two indicators, contained in
        the
        <a
          href="https://data-explorer.oecd.org/vis?df[ds]=dsDisseminateFinalDMZ&df[id]=DSD_RDTAX%40DF_RDTAX&df[ag]=OECD.STI.STP&df[vs]=1.0&pd=2015%2C&dq=.A..PT_B1GQ..&to[TIME_PERIOD]=false&ly[rw]=REF_AREA&ly[cl]=TIME_PERIOD&ly[rs]=MEASURE"
          target="_blank"
          >OECD R&D Tax Incentives database</a
        >, provide a complementary picture of governments' efforts to
        incentivise business R&D through the tax system. Moreover, it points to
        the latest OECD publications, working papers, policy papers and reports
        on R&D tax incentives. The descriptive and empirical OECD analysis
        contained in these documents shed light on the recent and long-term
        trends in the role of R&D tax incentives in the innovation policy mix
        across OECD countries and partner economies and provide insights into
        the impact of R&D tax incentives and direct support measures.
      </p>
    </div>
  </div>

  <!--Charts -->
  <ng-container *ngFor="let group of aggregationGroups">
    <div class="columns">
      <div class="column">
        <h2 class="title is-3 has-text-weight-bold has-line mt-4">
          {{ group.label }}
        </h2>
        <h3 *ngIf="group.subTitle" class="title is-5 has-text-weight-bold">
          {{ group.subTitle }}
        </h3>
        <div *ngIf="group.description" [innerHtml]="group.description"></div>
      </div>
    </div>
    <app-aggregation-widget
      [aggregations]="group.aggregations"
      layout="list"
    ></app-aggregation-widget>
  </ng-container>

  <div class="columns is-multiline" id="resources" *ngIf="sections">
    <div class="column is-12" *ngFor="let section of sections">
      <div class="content">
        <h2 class="title is-3 has-text-weight-bold has-line">
          {{ section.title }}
        </h2>

        <div class="columns is-multiline">
          <div
            *ngFor="let subSection of section.subSections"
            class="column"
            [ngClass]="{
              'is-6': subSection.isHalfWidth,
              'is-12': !subSection.isHalfWidth
            }"
          >
            <p class="has-text-weight-bold">{{ subSection.title }}</p>
            <ul>
              <li *ngFor="let item of subSection.items">
                <a [href]="item.link" target="_blank">{{ item.anchor }} </a>
                <ng-container *ngIf="item['extra-text']"
                  >&nbsp;
                  {{ item['extra-text']['pre-title'] }}
                  <a [href]="item['extra-text'].link" target="_blank">{{
                    item['extra-text'].anchor
                  }}</a>
                  {{ item['extra-text']['post-title'] }}
                </ng-container>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
